import { Box, Grid,GridItem,Flex,
  Heading,Image, Text,Circle,List,ListIcon,ListItem } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useLocation,Link, useNavigate } from "react-router-dom";
import { FaMinus as ListIkon } from "react-icons/fa";
import { RiLogoutBoxRLine as SignOutIcon } from "react-icons/ri";
import appStore,{userAtom,activePeriod} from "../../store";
import useView from "../../hooks/useView";
import path from "path";




const overview_icon = '/public-assets/overview.png';
const setting_icon = '/public-assets/setting.png';
const candidate_icon = '/public-assets/candidate.png';
const application_icon = '/public-assets/application.png';
const transaction_icon = '/public-assets/transaction.png';
const induction_icon = '/public-assets/induction.png';
const report_icon = '/public-assets/report.png';
const publish_icon = '/public-assets/publish.png';

type SubLinkType = {
  id:number;
  name:string;
  path:string;
}

type LinkType = {
  id:number;
  name:string;
  path:string;
  icon:string;
  subList?:SubLinkType[];
}

const list:LinkType[] = [
  {
    id:1,
    name:'Overview',
    path:'overview',
    icon:overview_icon
  },
  {
    id:2,
    name:'Settings',
    path:'settings',
    icon:setting_icon
  },
  {
    id:3,
    name:'Applications',
    path:'application',
    icon:candidate_icon,
    subList:[
      { 
        id:1,
        name:'Update Level',
        path:'update-level',
      },
       { 
        id:2,
        name:'Update Bio Data',
        path:'update-student-bio-data',
      }
    ]
  },
  
  {
    id:4,
    name:'Candidates',
    path:'candidates',
    icon:candidate_icon,
    subList:[
      { 
        id:1,
        name:'Registered Candidates',
        path:'register-candidate',
      },
        { 
        id:1,
        name:'Update Start Level',
        path:'update-start-level',
      },
      {
        id:2,
        name:'View Student Result',
        path:'view-student-result',
        },
    ]
  },
  {
    id:5,
    name:'Approvals',
    path:'approvals',
    icon:application_icon,
    subList:[
      { 
        id:1,
        name:'Change Email Approvals',
        path:'change-email-request',
        
      },
      {
      id:2,
      name:'Transcript Approvals',
      path:'transcript-request',
      },
      {
        id:3,
        name:'Deferment Approvals',
        path:'deferment-request',
        },
        {
          id:3,
          name:'Picture Approvals',
          path:'picture-approval',
          }
    ]
  },
  {
    id:6,
    name:'Transactions',
    path:'transactions',
    icon:transaction_icon,
    subList:[
     
      {
      id:1,
      name:'Transaction History',
      path:'transaction-history',
      },
      {
        id:2,
        name:'Upload Subscription Paymt',
        path:'upload-payment',
        },
        {
          id:3,
          name:'Process OffLine Payment',
          path:'process-off-line-payment',
          },
      { 
        id:4,
        name:'Confirm Requery Payment',
        path:'confirm-requery-payment',
        
      },
      { 
        id:5,
        name:'Treat Manual Subscription',
        path:'treat-manual-subscription',
        
      },
    ]
  },
  {
    id:7,
    name:'Induction',
    path:'induction',
    icon:induction_icon,
    subList:[
      { 
        id:1,
        name:'Upload OldInductee App/Subject',
        path:'upload-old-application',
        
      },
      { 
        id:2,
        name:'Generate Transcript',
        path:'gen-transcript',
        
      },
    ]
  },
  {
  id:8,
  name:'Publish Results',
  path:'publish-results',
  icon:publish_icon,
  subList:[
    { 
      id:1,
      name:'Review Subjects Results',
      path:'review-results',
      
    },
    { 
      id:2,
      name:'Publish Subject Results',
      path:'publish',
      
    },
  ]
},
  {
    id:9,
    name:'Reports',
    path:'reports',
    icon:report_icon,
    subList:[
      {
        id:1,
        name: 'Registered Candidate Report',
        path: 'registration-report',
      },
      {
        id:2,
        name: 'All Students Report',
        path: 'all-student-report',
      },
      {

       id:3,
      name:'Outstanding Dues Reports',
      path:'out-standing-dues-report',
      },

      // {
      //   id:3,
      //   name: 'Oustanding Resit Report',
      //   path: 'resit-report',
      // },

      // {
      // id:4,
      // name:'Not Registered Student Reports',
      // path:'not-registered-report',
      // },
      {
        id:5,
        name: 'Performance Report',
        path: 'performance-report',
      },
      {
        id:6,
        name: 'Transcript  Report',
        path: 'transcript-report',
        },
        {
          id:7,
          name: 'Student Score Report',
          path: 'score-report',
        },
      { 
        id:8,
        name: 'Induction Report',
        path:'due-induction-report',
        
      },
      // { 
      //   id:5,
      //   name: 'Applied For Induction Report',
      //   path:'applied-induction',
        
      // },
      { 
        id:9,
        name: 'Upgrade Subject Score Report',
        path:'student-score-report',
        
      },
      { 
        id:10,
        name: 'Report Of Student Moved',
        path:'moved-to-membership-report',
        
      },
      { 
        id:11,
        name: 'Application Report',
        path:'student-application-report',
        
      },
     ]
    },
  ]
  

const logo = '/public-assets/logo.png';
const SideBar = () => {
  const [active,set_active] = useState<null | number>(null);
  const view = useView();
  const location = useLocation();
  const redirect = useNavigate();
  const userInfo = appStore.get(userAtom);
  const handleSignOut = () => {
    localStorage.clear();
   // console.log('clicked');
    signOut();
    redirect('/');
  }

  useEffect(()=>{
    if(location && location.pathname){
      let currentPath = location .pathname;
      let cLink = currentPath.split('/')[1];
      if(cLink){
        let tempLink = list.find((eList:LinkType) => eList.path === cLink);
        if(tempLink){
          set_active(tempLink.id);
        }
      }
      else{
        set_active(list[0].id);
      }
    }
  },[location,location.pathname])

  return (
    <Flex flexDir="column" flexShrink="0" width="250px" height="100%" bg="var(--dark-green-color)" >
      <Grid templateColumns={'1fr'} gap="20px" bg="transparent" mt="20px" color="var(--white-color)" p="5px 0px 5px 20px">
        <GridItem as={Flex} gap="10px" align={"center"}>
          <Image src={logo}
            w="40px"
            h="40px"
            alt="logo"
            objectPosition="center"
            objectFit="contain"
          />
          <Box>
            <Heading m="0" fontSize={".9rem"}>CIPM</Heading>
            <Text m="0" fontSize={".8rem"} mt="2px">Examination Portal</Text>
          </Box>
        </GridItem>
        <GridItem as={Flex} gap="10px" align={"center"} >
          <Circle size={"40px"} bg="var(--faded-green)" color={"var(--dark-green-color)"}>
            {userInfo?.FirstName.slice(0,2).toUpperCase()}
          </Circle>
          <Box>
            <Heading m="0" fontSize={".9rem"}>{userInfo?.FirstName.toUpperCase()}</Heading>
            <Text m="0" fontSize={".8rem"} mt="2px">{userInfo?.Role || 'Admin'}</Text>
          </Box>
        </GridItem>
      </Grid>
      <Flex sx={{'::-webkit-scrollbar':{width:'1px'}}} flexDir="column" h="calc(100% - 110px)" overflowX="clip" overflowY="auto">
        <Grid templateColumns={"1fr"} gap="10px" p="0 10px" mt="20px">
          {list.map(({id,name,path,icon,subList}:LinkType )=>{
            let check = name.toLowerCase() === 'overview'? true : view(name);
            
            if(check){
              
              return(
                <GridItem key={id}>
              <Box as={Link} display="flex" borderRadius="17px" alignItems={"center"} p="7px 15px"    
                gap="10px" to={`/${path}`} sx={{bg:`${active ==id?'var(--highlight-green)':''}`, ":hover":{bg:"var(--highlight-green)"}
              }}>
                <Image 
                  w={"20px"}
                  h="20px"
                  src={icon}
                  objectFit={"contain"}
                  objectPosition={"center"}
                  alt="icon"
                />
                <Box as="span" color="var(--white-color)">{name}</Box>
              </Box>
              {active == id && subList && subList.length> 0 ?
                <List mb="10px">
                  { subList.map(({id:subId,name:subName,path:subPath}:SubLinkType)=>{
                    // let check = subName.toLowerCase() === 'overview'? true : view(subName);
                    // if(!check) return <></>
                    return <ListItem key={subId} color="var(--white-color)" pl="20px" mt="8px" fontSize=".8rem">
                      <Link to={`/${path}/${subPath}`}>
                        <ListIcon><ListIkon/></ListIcon>
                        {subName}
                      </Link>
                    </ListItem>}
                  )}                
                </List>
                :''
              }
            
            </GridItem>
              )
            }
            else{
              return '';
            }
            }
            )}
          
        </Grid>
        <Flex color="white" p="10px 20px" align="center" gap="10px" mt="20px">
          
          <span onClick={handleSignOut} style={{fontSize:'22px',cursor:'pointer'}} >
            <SignOutIcon/>
          </span>
          <span onClick={handleSignOut} style={{cursor:'pointer'}} > Sign out </span>
         
        </Flex> 

      </Flex>
      

    </Flex>
  
  )
}

export default SideBar


function signOut(): any {
  appStore.set(userAtom,{
      AdminUserHasChangePassword:false,
      FirstName:'',
      Id:'',
      Role:'',
      Token:'',
      UserName:'',
      expiryDate:"",
      justLogged:false,
      RoleNames:[],
      Permissions:[],
      PathName:[]
    }
  )
  appStore.set(activePeriod,{
    Id:1,
    Name:'March'
  })
  return false;
  // throw new Error("Function not implemented.");
}
